var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00944 15.8334H7.59277C4.25944 15.8334 2.59277 15 2.59277 10.8334V6.66669C2.59277 3.33335 4.25944 1.66669 7.59277 1.66669H14.2594C17.5928 1.66669 19.2594 3.33335 19.2594 6.66669V10.8334C19.2594 14.1667 17.5928 15.8334 14.2594 15.8334H13.8428C13.5844 15.8334 13.3344 15.9584 13.1761 16.1667L11.9261 17.8334C11.3761 18.5667 10.4761 18.5667 9.92611 17.8334L8.67611 16.1667C8.54277 15.9834 8.23444 15.8334 8.00944 15.8334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75977 6.66669H15.0931",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75977 10.8333H11.7598",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.468dd347544df5837414849f3ec0dd08.svg";
export { ForwardRef as ReactComponent };